import { useCallback } from 'react';
import { exception } from '@erikdakoda/log/exception';
import { useSnack } from './useSnack';

export const useException = (): ((
  err: unknown,
  outerMessage?: string,
  quiet?: boolean,
) => string) => {
  const { snack } = useSnack();

  return useCallback(
    (err: unknown, outerMessage?: string, quiet?: boolean) => {
      const message = exception(err, outerMessage);
      if (!quiet) {
        snack.error(message);
      }
      return message;
    },
    [snack],
  );
};

export type UseExceptionHook = ReturnType<typeof useException>;
